module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_42-9491ef3a2fa5a011b33145304648f83b.png";